import { useTheme } from '../../context/theme'
import { Icon } from '@/design-system/atoms/Icon'

interface ThemeToggleProps {
  variant?: 'default' | 'prominent'
}

/**
 * Theme Toggle Component
 *
 * @param variant - 'default' for subtle border style, 'prominent' for brand color background
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  variant = 'default',
}) => {
  const { toggleTheme } = useTheme()

  const variantClasses = {
    default:
      'h-11 w-11 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-700 dark:hover:text-white',
    prominent: 'size-14 bg-brand-500 hover:bg-brand-600 text-white',
  }

  return (
    <button
      onClick={toggleTheme}
      className={`relative inline-flex items-center justify-center transition-colors rounded-full ${variantClasses[variant]}`}
      aria-label="Alternar tema"
    >
      {/* Sun: dark → light */}
      <span className="hidden dark:inline-flex">
        <Icon name="sun" size={20} />
      </span>
      {/* Moon: light → dark */}
      <span className="inline-flex dark:hidden">
        <Icon name="moon" size={20} />
      </span>
    </button>
  )
}

export default ThemeToggle
